export const cb_table = {
  '001': 'Reading: time and one-half (+50%)',
  '002': 'Reading: double time (+100%)',
  '003': 'Reading: more than double time (>+100%)',
  '004': 'Writing: time and one-half (+50%)',
  '005': 'Writing: double time (+100%)',
  '006': 'Writing: more than double time (>+100%)',
  '007': 'Math: time and one-half (+50%)',
  '008': 'Math: double time (+100%)',
  '009': 'Math: more than double time (>+100%)',
  '010': 'Listening: time and one-half (+50%)',
  '011': 'Listening: double time (+100%)',
  '012': 'Listening: more than 100% (>+100%)',
  '013': 'Speaking: time and one-half (+50%)',
  '014': 'Speaking: double time (+100%)',
  '015': 'Speaking: more than double time (>+100%)',
  '016': 'Extra Breaks',
  '017': 'Extended Breaks',
  '018': 'Breaks as needed',
  '019': 'Permission to test blood sugar',
  '020': 'Other (breaks)',
  '021': 'Large print test book: other',
  '022': 'Large print test book: 14 point',
  '023': 'Large print test book: 20 point',
  '024': 'Large print (large block) answer sheet',
  '025': 'Human reader (assistive technology can be used)',
  '026': 'MP3 (assistive technology can be used)',
  '027': 'Braille',
  '028': 'Magnification device (non-electronic)',
  '029': 'Magnification device (electronic)',
  '030': 'Braille (assistive Technology can be used)',
  '031': 'Other',
  '032': 'Large print (large block) answer sheet',
  '033': 'Computer (word processor ONLY for essays ONLY)',
  '034': 'Writer/scribe (assistive technology can be used)',
  '035': 'Braille Writer',
  '036': 'Record answers in Test book',
  '037': 'Other',
  '038': 'Preferential seating',
  '039': 'Small group testing',
  '040': 'School-based testing',
  '041': 'One-to-one testing',
  '042': 'Food/drink/medication',
  '043': 'Printed copy of verbal instructions',
  '044': 'Sign language interpreter for oral instructions ONLY',
  '045': 'Other',
  '046': 'Limited Time Testing',
  '047': 'Home / hospital testing',
  '048': 'Wheelchair accessibility',
  '049': 'Other',
  '050': 'Assistive technology',
  '051': 'Auditory amplification / FM system',
  '083': 'Other Center Based',
  '128': 'ATC form (Assistive technology can be used)',
  '129': '4-function calculator',
  '145': 'Colored overlay',
  '149': 'EL time and one-half (+50%)',
  '200': 'Paper Test for digital assessments',
  '201': 'Screen reader/text-to-speech',
  '202': 'Dictation for digital tests (speech-to-text)',
  '203': 'Braille, UEB Technical',
  '204': 'Human Reader for digital tests',
  '205': 'Scribe for digital tests',
  '300': 'SE - Paper test for digital assessments',
};

export const digital_cb_table = {
  '001': 'Reading: Up to Time and one-half (+50%)',
  '002': 'Reading: Up to Double time (+100%)',
  '003': 'Reading: Up to More than double time (>+100%)',
  '004': 'Writing: Up to Time and one-half (+50%)',
  '005': 'Writing: Up to Double time (+100%)',
  '006': 'Writing: Up to More than double time (>+100%)',
  '007': 'Math: Up to Time and one-half (+50%)',
  '008': 'Math: Up to Double time (+100%)',
  '009': 'Math: Up to More than double time (>+100%)',
  '010': 'Listening: time and one-half (+50%)',
  '011': 'Listening: double time (+100%)',
  '012': 'Listening: more than 100% (>+100%)',
  '013': 'Speaking: time and one-half (+50%)',
  '014': 'Speaking: double time (+100%)',
  '015': 'Speaking: more than double time (>+100%)',
  '016': 'Extra Breaks',
  '017': 'Extended Breaks',
  '018': 'Breaks as needed',
  '019': 'Permission to test blood sugar',
  '020': 'Other (breaks)',
  '021': 'Large Print - AP Paper Exams or Approved Paper Testing Only - Other',
  '022': 'Large Print - AP Paper Exams or Approved Paper Testing Only - 14 PT',
  '023': 'Large Print - AP Paper Exams or Approved Paper Testing Only - 20 PT',
  '024': 'Large Print Answer Sheet for Paper Exams (AP and other if approved)',
  '025': 'Human reader for AP Paper Exams',
  '026': 'Pre-recorded audio (uses screen reader)',
  '027': 'Refreshable Braille',
  '028': 'Magnification device (non-electronic)',
  '029': 'Magnification Device (electronic)',
  '030': 'Raised Line Drawings',
  '031': 'Other (reading/seeing text)',
  '032': 'Large Print Answer Sheet for Paper Exams (AP and other if approved)',
  '033': 'Computer to Type Essay or Free Response',
  '034': 'Writer/Scribe for AP Paper Exams',
  '035': 'Braille Writer',
  '036': 'Record answers in test book for AP Paper Exams',
  '037': 'Other (recording responses)',
  '038': 'Preferential seating',
  '039': 'Small group testing',
  '040': 'School-based testing',
  '041': 'One-to-one testing',
  '042': 'Food/drink/medication',
  '043': 'Printed copy of verbal instructions for paper exams (AP and other if approved)',
  '044': 'Sign language interpreter for oral instructions ONLY',
  '045': 'Other',
  '046': 'Limited Time Testing',
  '047': 'Home / Hospital Testing',
  '048': 'Wheelchair accessibility',
  '049': 'Other (modified setting)',
  '050': 'Assistive technology',
  '051': 'Auditory amplification / FM system',
  '083': 'Other Center-based',
  '087': 'State-Allowed: Breaks: Extra',
  '092': 'State-Allowed: One-to-One Testing',
  '093': 'State-Allowed: Small Group Testing',
  '094': 'State-Allowed: Human Reader for digital tests',
  '095': 'State-Allowed: Sign Language Interpreter',
  '096': 'State-Allowed: Limited Time Testing',
  '097': 'State-Allowed: Assistive Technology',
  '103': 'State-Allowed: Writer/Scribe for digital tests',
  '104': 'State-Allowed: Magnification device (electronic/non-electronic)',
  '105': 'State-Allowed: Use of Math Aids (e.g. Manipulatives, Ruler, Abacus, etc.)',
  '109': 'State-Allowed: Permission for Food/Drinks/Medication',
  '110': 'State-Allowed: Clarification of Directions',
  '111': 'State-Allowed: Use of Non-Electronic Reading/Writing Aids',
  '112': 'State-Allowed: Auditory Amplification / FM System',
  '115': 'State-Allowed: Reading content & questions in native language',
  '117': 'State-Allowed: Sign language interpreter for test content and/or responses',
  '123': 'State-Allowed: Reading - Up to Time and one-half (+50%)',
  '124': 'State-Allowed: Reading - Up to Double time (+100%)',
  '125': 'State-Allowed: Reading - Up to More than double time (>+100%)',
  '126': 'State-Allowed: Essay - Up to Time and one-half (+50%)',
  '127': 'State-Allowed: Essay - Up to Double time (+100%)',
  '128': 'Assistive Technology Compatible Test form (ATC)',
  '129': '4-function Calculator',
  '130': 'State-Allowed: Essay - Up to More than double time (>+100%)',
  '131': 'State-Allowed: Math - Up to Time and one-half (+50%)',
  '132': 'State-Allowed: Math - Up to Double time (+100%)',
  '133': 'State-Allowed: Math - Up to More than double time (>+100%)',
  '134': 'State-Allowed: Home/Hospital',
  '135': 'State-Allowed: Other Accommodation',
  '140': 'State-Allowed: Raised Line Drawings',
  '145': 'Colored overlay/color contrast',
  '146': 'State-Allowed: EL - Math Only Testing',
  '147': 'State-Allowed: EL - Oral Translation of Math',
  '149': 'EL - Up to Time and one-half (+50%)',
  '150': 'State-Allowed: Screen Reader (Non-embedded) for Entire Digital Test',
  '151': 'State-Allowed: Dictation for digital tests',
  '152': 'State-Allowed: Text-to-Speech for Entire Digital Test (Embedded)',
  '153': 'State-Allowed: Breaks: Extended',
  '154': 'State-Allowed: Breaks as needed',
  '155': 'State-Allowed: Text-to-Speech for Math Sections (Embedded)',
  '156': 'State-Allowed: Screen Reader for Math Sections (Non-embedded)',
  '157': 'EL - Text-to-Speech for Math Sections (Embedded)',
  '158': 'EL - Math-Only Test',
  '200': 'Paper test for digital assessments',
  '201': 'Screen Reader (Non-embedded) for Entire Digital Test',
  '202': 'Dictation for digital tests (speech-to-text)',
  '203': 'Braille Paper Testing - UEB with Technical Math',
  '204': 'Human Reader for digital tests',
  '205': 'Scribe for digital tests',
  '206': 'Extra Breaks Math Only',
  '207': 'Extra Breaks Essay Only',
  '208': 'Nutrition break',
  '209': 'Text-to-Speech for Entire Digital Test (Embedded)',
  '210': 'Text-to-Speech for Math Sections (Embedded)',
  '211': 'Screen Reader for Math Sections (Non-embedded)',
  '212': 'Braille Paper Testing - UEB with Nemeth Code',
  '213': 'Extra Playbacks of Audio',
  '214': 'Captions for Aural Prompts',
  '215': 'Human Reader for AP Aural Prompts',
  '300': 'SE - Paper test for digital assessments',
};
